// extracted by mini-css-extract-plugin
export default {"tabButton":"tabButton-b6F6O","btn":"btn-plXoK","btnless":"btnless-kqaEq","btnone":"btnone-QTYqy","btnActive":"btnActive-B2umo"};